export default "https://cdn-static.gokick.com/assets/e388117c7865c86e8cffce5bc7abacefcd582b49/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";